import script from "./SlotTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SlotTable.vue?vue&type=script&setup=true&lang=js"

import "./SlotTable.vue?vue&type=style&index=0&id=34e48af9&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34e48af9"]])

export default __exports__